export const products = {
  categories: [
    {
      name: 'Featured',
      translationId: 'featured',
      description: 'Featured ',
      icon: 'featured',
      products: [
        {
          name: 'Cloud Pak for AIOps',
          longDescription:
            'DevOps management tool with AI analysis and recommendations',
          url: '/products/cloud-pak-for-watson-aiops',
          pricingUrl: '/products/cloud-pak-for-watson-aiops/pricing',
          translationId: 'watsonAiops',
          external: false,
        },
        {
          name: 'Cloud Pak for Business automation',
          longDescription: 'Operations management software with AI insights',
          url: '/products/cloud-pak-for-business-automation',
          pricingUrl: '/products/cloud-pak-for-business-automation/pricing',
          translationId: 'cloudpakba',
          external: false,
        },
        {
          name: 'Cloud Pak for Data',
          longDescription:
            'Tools for data analysis, organization and management',
          url: '/products/cloud-pak-for-data',
          pricingUrl: null,
          translationId: 'pakData',
          external: false,
        },
        {
          name: 'Cloud Pak for Integration',
          longDescription: 'Tools to connect all of your apps, data and events',
          url: '/products/cloud-pak-for-integration',
          pricingUrl: '/products/cloud-pak-for-integration/pricing',
          translationId: 'pakIntegration',
          external: false,
        },
        {
          name: 'Cloud Pak for Network Automation',
          longDescription: 'Management software for telco network operations',
          url: '/products/cloud-pak-for-network-automation',
          pricingUrl: '/products/cloud-pak-for-network-automation/pricing',
          translationId: 'cloudpakna',
          external: false,
        },
        {
          name: 'Cloud Pak for Security',
          longDescription:
            'Security auditing, reporting, analysis and governance',
          url: '/products/cloud-pak-for-security',
          pricingUrl: '/products/cloud-pak-for-security/pricing',
          translationId: 'pakSecurity',
          external: false,
        },
        {
          name: 'IBM Cloud',
          longDescription: 'On-demand cloud computing platform and APIs',
          url: '/cloud',
          translationId: 'cloudAll',
          pricingUrl: null,
          external: false,
        },
        {
          name: 'z16',
          longDescription:
            'Flagship mainframe with on-chip AI and quantum-safe cryptography',
          url: '/products/z16',
          translationId: 'z16',
          pricingUrl: null,
          external: false,
        },
      ],
    },
    {
      name: 'AI & machine learning',
      translationId: 'ai',
      description: 'Use Watson’s AI or build your own machine learning models',
      icon: 'https://1.cms.s81c.com/sites/default/files/2019-05-23/product-AI.svg',
      link: '/artificial-intelligence',
      products: [
        {
          name: 'Cloud Pak for AIOps',
          longDescription:
            'DevOps management tool with AI analysis and recommendations',
          url: '/products/cloud-pak-for-watson-aiops',
          pricingUrl: '/products/cloud-pak-for-watson-aiops/pricing',
          translationId: 'watsonAiops',
          external: false,
        },
        {
          name: 'Cloud Pak for Data',
          longDescription:
            'Tools for data analysis, organization and management',
          url: '/products/cloud-pak-for-data',
          pricingUrl: '/products/cloud-pak-for-data/pricing',
          translationId: 'pakData',
          external: false,
        },
        {
          name: 'Watson Assistant',
          longDescription: 'Virtual agents customizable to any domain',
          translationId: 'watsonAssistant',
          url: '/products/watson-assistant',
          pricingUrl: '/products/watson-assistant/pricing',
          external: false,
        },
        {
          name: 'Watson Discovery',
          longDescription:
            'Search and analytics engine that adapts to custom domains',
          translationId: 'watsonDiscovery',
          url: '/cloud/watson-discovery',
          pricingUrl: 'watson-discovery/pricing',
          external: false,
        },
        {
          name: 'Watson Knowledge Catalog',
          longDescription: 'SaaS for AI data management',
          translationId: 'watsonCatalog',
          url: '/cloud/watson-knowledge-catalog',
          pricingUrl: '/cloud/watson-knowledge-catalog/pricing',
          external: false,
        },
        {
          name: 'Watson NLU',
          longDescription: 'API for text analysis and metadata extraction',
          translationId: 'watsonNlu',
          url: '/cloud/watson-natural-language-understanding',
          pricingUrl: 'cloud/watson-natural-language-understanding/pricing',
          external: false,
        },
        {
          name: 'Watson Speech to Text',
          longDescription:
            'API for real-time speech recognition and transcription',
          translationId: 'watsonSpeechToText',
          url: '/cloud/watson-speech-to-text',
          pricingUrl: '/cloud/watson-speech-to-text/pricing',
          external: false,
        },
        {
          name: 'Watson Studio',
          longDescription: 'IDE to build, run and manage AI models',
          translationId: 'watsonStudio',
          url: '/cloud/watson-studio',
          pricingUrl: '/cloud/watson-studio/pricing',
          external: false,
        },
        {
          name: 'Watson Text to Speech',
          longDescription: 'API for real-time text to speech conversion',
          translationId: 'watsonTextToSpeech',
          url: '/cloud/watson-text-to-speech',
          pricingUrl: '/cloud/watson-text-to-speech/pricing',
          external: false,
        },
      ],
    },
    {
      name: 'Analytics',
      translationId: 'analytics',
      description: 'Aggregate and analyze large datasets',
      icon: 'analytics.svg',
      link: '/analytics',
      products: [
        {
          name: 'Cloud Pak for Data',
          longDescription:
            'Tools for data analysis, organization and management',
          url: '/products/cloud-pak-for-data',
          pricingUrl: '/products/cloud-pak-for-data/pricing',
          translationId: 'pakData',
          external: false,
        },
        {
          name: 'Cognos Analytics',
          longDescription:
            'Software for business intelligence and performance management',
          translationId: 'cognosAnalytics',
          url: '/products/cognos-analytics',
          pricingUrl: '/products/cognos-analytics/pricing',
          external: false,
        },
        {
          name: 'CPLEX',
          longDescription:
            'Software to build and solve complex optimization models',
          translationId: 'cplex',
          url: '/products/ilog-cplex-optimization-studio',
          pricingUrl: '/products/ilog-cplex-optimization-studio/pricing',
          external: false,
        },
        {
          name: 'Information Server',
          longDescription:
            'Data integration suite for ETL, governance and anlaysis',
          translationId: 'infoServer',
          url: '/information-server',
          pricingUrl: null,
          external: false,
        },
        {
          name: 'Netezza',
          longDescription:
            'Data warehousing and analytics system on custom hardware',
          translationId: 'netezza',
          url: '/products/netezza',
          pricingUrl: '/products/netezza/pricing',
          external: false,
        },
        {
          name: 'Optim',
          longDescription:
            'Software to manage test, production, and archived data',
          translationId: 'optim',
          url: '/infosphere-optim',
          pricingUrl: null,
          external: false,
        },
        {
          name: 'Planning Analytics',
          longDescription:
            'Software to automate financial and operational planning',
          translationId: 'planningAnalytics',
          url: '/products/planning-analytics',
          pricingUrl: '/products/planning-analytics/pricing',
          external: false,
        },
        {
          name: 'SPSS',
          longDescription:
            'Software for statistical analysis and business intelligence',
          translationId: 'spss',
          url: '/spss',
          pricingUrl: null,
          external: false,
        },
        {
          name: 'Watson Discovery',
          longDescription:
            'Search and analytics engine that adapts to custom domains',
          translationId: 'watsonDiscovery',
          url: '/cloud/watson-discovery',
          pricingUrl: 'watson-discovery/pricing',
          external: false,
        },
        {
          name: 'Watson Studio',
          longDescription: 'IDE to build, run and manage AI models',
          translationId: 'watsonStudio',
          url: '/cloud/watson-studio',
          pricingUrl: '/cloud/watson-studio/pricing',
          external: false,
        },
      ],
    },
    {
      name: 'Asset management',
      translationId: 'assetManagement',
      description: 'Manage and maintain physical assets',
      icon: 'asset-management.svg',
      products: [
        {
          name: 'Environmental Intelligence Suite',
          longDescription:
            'SaaS for predicting and responding to weather and climate events',
          translationId: 'environmentIntelligence',
          url: '/products/environmental-intelligence-suite',
          pricingUrl: '/products/environmental-intelligence-suite/pricing',
          external: false,
        },
        {
          name: 'Envizi',
          longDescription:
            'SaaS to analyze environmental, social and governance indicators',
          translationId: 'envizi',
          url: '/products/envizi',
          pricingUrl: null,
          external: false,
        },
        {
          name: 'Maximo',
          longDescription:
            'Software for asset management and related workflows',
          translationId: 'maximo',
          url: '/products/maximo',
          pricingUrl: '/products/maximo/pricing',
          external: false,
        },
        {
          name: 'TRIRIGA',
          longDescription: 'Software for real estate and workplace management',
          translationId: 'tririga',
          url: '/products/tririga',
          pricingUrl: '/products/tririga/pricing',
          external: false,
        },
      ],
    },
    {
      name: 'Business automation',
      translationId: 'automation',
      description: 'Automate workflows and business processes',
      icon: 'business-automation',
      link: '/automation',
      products: [
        {
          name: 'BlueWorks Live',
          longDescription:
            'SaaS for collaboratively modeling business processes',
          translationId: 'blueworks',
          url: '/products/blueworkslive',
          pricingUrl: '/products/blueworkslive/pricing',
          external: false,
        },
        {
          name: 'Business Automation Workflow',
          longDescription:
            'Cloud Pak for Business Automation addon to automate workflows',
          translationId: 'baWorkflow',
          url: '/products/business-automation-workflow',
          pricingUrl: '/products/business-automation-workflow/pricing',
          external: false,
        },
        {
          name: 'Cloud Pak for Business Automation',
          longDescription: 'Operations management software with AI insights',
          url: '/products/cloud-pak-for-business-automation',
          pricingUrl: '/products/cloud-pak-for-business-automation/pricing',
          translationId: 'cloudpakba',
          external: false,
        },
        {
          name: 'FileNet Content Manager',
          longDescription:
            'Content management solution for Cloud Pak for Business Automation',
          translationId: 'filenet',
          url: '/products/filenet-content-manager',
          pricingUrl: null,
          external: false,
        },
        {
          name: 'Operational Decision Manager',
          longDescription:
            'Cloud Pak for Business Automation addon for rule-based decisions',
          translationId: 'operationalManager',
          url: '/products/operational-decision-manager',
          pricingUrl: '/products/operational-decision-manager/pricing',
          external: false,
        },
        {
          name: 'Process Mining',
          longDescription:
            'Software to extract process data from business applications',
          translationId: 'processMining',
          url: '/products/process-mining',
          pricingUrl: null,
          external: false,
        },
        {
          name: 'Robotic Process Automation (RPA)',
          longDescription:
            'Software to automate workflows and business processes',
          translationId: 'roboticAutomation',
          url: '/products/robotic-process-automation',
          pricingUrl: '/products/robotic-process-automation/pricing',
          external: false,
        },
        {
          name: 'Watson Orchestrate',
          longDescription:
            'Personal-assistant software that automates repetitive tasks',
          translationId: 'watsonOrchestrate',
          url: 'https://www.ibm.com/products/watson-orchestrate',
          pricingUrl: null,
          external: false,
        },
      ],
    },
    {
      name: 'Compute & servers',
      translationId: 'compute',
      description: 'Run workloads on cloud infrastructure',
      icon: 'compute-and-servers',
      link: '/servers',
      products: [
        {
          name: 'Cloud Bare Metal Servers',
          longDescription: 'Dedicated hardware for maximum performance',
          url: '/cloud/bare-metal-servers',
          pricingUrl: '/cloud/bare-metal-servers/pricing',
          translationId: 'bareMetal',
          external: false,
        },
        {
          name: 'Cloud Virtual Servers for VPC',
          longDescription: 'Virtual servers with Intel Xeon or IBM Z CPUs',
          url: '/cloud/virtual-servers',
          pricingUrl: '/cloud/virtual-servers/pricing',
          translationId: 'vpc',
          external: false,
        },
        {
          name: 'LinuxONE',
          longDescription: 'Physical and virtual servers for running Linux',
          translationId: 'linuxOne',
          url: '/linuxone',
          pricingUrl: null,
          external: false,
        },
        {
          name: 'Power',
          longDescription: 'Physical and virtual servers with IBM Power CPUs',
          translationId: 'power',
          url: '/power',
          pricingUrl: null,
          external: false,
        },
        {
          name: 'Spectrum Computing',
          longDescription:
            'Software to manage large-scale storage devices and data',
          translationId: 'spectrumComputing',
          url: '/spectrum-computing',
          pricingUrl: null,
          external: false,
        },
        {
          name: 'z15',
          longDescription: 'Previous generation of the IBM Z mainframe',
          translationId: 'z15',
          url: '/products/z15',
          pricingUrl: null,
          external: false,
        },
        {
          name: 'z16',
          longDescription:
            'Flagship mainframe with on-chip AI and quantum-safe cryptography',
          url: '/products/z16',
          translationId: 'z16',
          pricingUrl: null,
          external: false,
        },
      ],
    },
    {
      name: 'Database',
      translationId: 'databases',
      description: 'Store, query and analyze structured data',
      icon: 'databases',
      link: '/cloud/databases',
      products: [
        {
          name: 'Cloudant',
          longDescription:
            'Managed PCI-compliant JSON document store on CouchDB',
          url: '/cloud/cloudant',
          pricingUrl: '/cloud/cloudant/pricing',
          translationId: 'cloudant',
          external: false,
        },
        {
          name: 'Db2',
          longDescription:
            'Data management software including IBM Db2 Database',
          translationId: 'db2',
          url: '/products/db2',
          pricingUrl: null,
          external: false,
        },
        {
          name: 'Db2 for z/OS',
          longDescription: 'IBM Db2 Database for IBM Z mainframes',
          translationId: 'db2ZOS',
          url: '/products/db2-for-zos',
          pricingUrl: null,
          external: false,
        },
        {
          name: 'Hyper Protect DbaaS',
          longDescription: 'Managed PostgreSQL and MongoDB for sensitive data',
          translationId: 'hyperDbaas',
          url: '/cloud/hyper-protect-dbaas',
          pricingUrl: '/cloud/hyper-protect-dbaas/pricing',
          external: false,
        },
        {
          name: 'IBM Cloud Databases for MongoDB',
          longDescription: 'Managed NoSQL JSON document store',
          url: '/cloud/databases-for-mongodb',
          pricingUrl: '/cloud/databases-for-mongodb/pricing',
          translationId: 'databasesForMongodb',
          external: false,
        },
        {
          name: 'IBM Cloud Databases for MySQL',
          longDescription: 'Managed SQL database',
          url: '/cloud/databases-for-mysql',
          pricingUrl: '/cloud/databases-for-mysql',
          translationId: 'databasesForMysql',
          external: false,
        },
        {
          name: 'IBM Cloud Databases for PostgreSQL',
          longDescription: 'Managed SQL database with advanced features',
          url: '/cloud/databases-for-postgresql',
          pricingUrl: '/cloud/databases-for-postgresql/pricing',
          translationId: 'databasesForPostgresql',
          external: false,
        },
        {
          name: 'IMS',
          longDescription:
            'Database and management system for high-volume transactions',
          translationId: 'ims',
          url: '/products/ims',
          pricingUrl: '/products/ims/pricing',
          external: false,
        },
        {
          name: 'Informix',
          longDescription:
            'Embeddable database for SQL, NoSQL, time-series and spatial data',
          translationId: 'informix',
          url: '/products/informix',
          pricingUrl: '/products/informix/pricing',
          external: false,
        },
      ],
    },
    {
      name: 'DevOps',
      translationId: 'devops',
      description: 'Manage infrastructure, environments and deployments',
      icon: 'devops',
      url: 'https://www.ibm.com/devops',
      products: [
        {
          name: 'Cloud Continuous Delivery',
          longDescription:
            'UI and CLI based DevOps workflows based on Tekton Pipelines',
          translationId: 'ccDelivery',
          url: '/cloud/continuous-delivery',
          pricingUrl: null,
          external: false,
        },
        {
          name: 'Cloud Pak for AIOps',
          longDescription:
            'DevOps management tool with AI analysis and recommendations',
          translationId: 'watsonAiops',
          url: '/products/cloud-pak-for-watson-aiops',
          pricingUrl: '/products/cloud-pak-for-watson-aiops/pricing',
          external: false,
        },
        {
          name: 'Engineering Lifecycle Management',
          longDescription:
            'Software for product and application lifecycle management',
          translationId: 'engineeringLifecycle',
          url: '/products/engineering-lifecycle-management',
          pricingUrl: '/products/engineering-lifecycle-management/pricing',
          external: false,
        },
        {
          name: 'Event Streams',
          longDescription: 'PaaS stream processing based on Apache Kafka',
          translationId: 'eventStreams',
          url: '/cloud/event-streams',
          pricingUrl: null,
          external: false,
        },
        {
          name: 'UrbanCode',
          longDescription:
            'Software for continuous integration and deployment pipelines',
          translationId: 'urbanCode',
          url: '/cloud/urbancode',
          pricingUrl: null,
          external: false,
        },
      ],
    },
    {
      name: 'IT automation',
      translationId: 'itAutomation',
      description: 'Automate IT infrastructure mangement',
      icon: 'it-automation',
      url: '/automation',
      products: [
        {
          name: 'Cloud Pak for AIOps',
          longDescription:
            'DevOps management tool with AI analysis and recommendations',
          url: '/products/cloud-pak-for-watson-aiops',
          pricingUrl: '/products/cloud-pak-for-watson-aiops/pricing',
          translationId: 'watsonAiops',
          external: false,
        },
        {
          name: 'Flexera One',
          longDescription: 'IT asset management and cloud optimization',
          translationId: 'flexera',
          url: '/products/flexera-one',
          pricingUrl: null,
          external: false,
        },
        {
          name: 'Instana',
          longDescription:
            'Software for application performance monitoring and automation',
          translationId: 'instana',
          url: '/products/instana',
          pricingUrl: '/products/instana/pricing',
          external: false,
        },
        {
          name: 'Turbonomic',
          longDescription: 'Software to manage and optimize IT resource usage',
          translationId: 'turbonomic',
          url: '/products/turbonomic',
          pricingUrl: null,
          external: false,
        },
      ],
    },
    {
      name: 'Middleware',
      description: 'Connect your applications, data and events',
      translationId: 'middleware',
      icon: 'middleware',
      url: '/products/cloud-pak-for-integration',
      products: [
        {
          name: 'API Connect',
          longDescription: 'Toolkit to rapidly create, secure and manage APIs',
          translationId: 'apiConnect',
          url: '/products/api-connect',
          pricingUrl: '/products/api-connect/pricing',
          external: false,
        },
        {
          name: 'APP Connect',
          longDescription: 'Codeless connectors for your data, apps and APIs',
          translationId: 'appConnect',
          url: '/products/app-connect',
          pricingUrl: '/products/app-connect/pricing',
          external: false,
        },
        {
          name: 'Aspera',
          longDescription:
            'System to transfer, sync or stream huge data globally',
          translationId: 'aspera',
          url: '/products/aspera',
          pricingUrl: '/products/aspera/pricing',
          external: false,
        },
        {
          name: 'Cloud Pak for Integration',
          longDescription: 'Tools to connect all of your apps, data and events',
          url: '/products/cloud-pak-for-integration',
          pricingUrl: '/products/cloud-pak-for-integration/pricing',
          translationId: 'pakIntegration',
          external: false,
        },
        {
          name: 'DataPower',
          longDescription: 'Physical or virtual multi-protocol network gateway',
          translationId: 'dataPower',
          url: '/products/datapower-gateway',
          pricingUrl: '/products/datapower-gateway/pricing',
          external: false,
        },
        {
          name: 'MQ',
          longDescription:
            'Software and hardware for messaging between distributed systems',
          translationId: 'mq',
          url: '/products/mq',
          pricingUrl: '/products/mq/pricing',
          external: false,
        },
        {
          name: 'WebSphere Application Server',
          longDescription: 'Runtime and SDK for Java applications',
          translationId: 'websphereApp',
          url: '/products/websphere-application-server',
          pricingUrl: '/products/websphere-application-server/pricing',
          external: false,
        },
      ],
    },
    {
      name: 'Network',
      translationId: 'network',
      description: 'Run and manage public, private and virtual networks',
      icon: 'network',
      products: [
        {
          name: 'Cloud Pak for Network Automation',
          longDescription: 'Management software for telco network operations',
          url: '/products/cloud-pak-for-network-automation',
          pricingUrl: '/products/cloud-pak-for-network-automation/pricing',
          translationId: 'cloudpakna',
          external: false,
        },
        {
          name: 'Edge Application Manager',
          longDescription: 'Management platform for edge computing',
          translationId: 'edgeApp',
          url: '/cloud/edge-application-manager',
          pricingUrl: null,
          external: false,
        },
        {
          name: 'SevOne Network Performance Management',
          longDescription:
            'Software to collect and analyze network performance data',
          translationId: 'sevOne',
          url: '/products/sevone-network-performance-management',
          pricingUrl: null,
          external: false,
        },
      ],
    },
    {
      name: 'Operating system',
      translationId: 'os',
      description: 'Run critical workloads on specialized operating systems',
      icon: 'operating-system',
      link: '/servers',
      products: [
        {
          name: 'AIX',
          longDescription: 'UNIX operating system for Power servers',
          translationId: 'aix',
          url: '/products/aix',
          pricingUrl: null,
          external: false,
        },
        {
          name: 'IBM i',
          longDescription: 'Integrated operating system for Power servers',
          translationId: 'ibmI',
          url: '/products/ibm-i',
          pricingUrl: null,
          external: false,
        },
        {
          name: 'z/OS',
          longDescription:
            'Flagship OS for continuous, high-volume mainframe operation',
          translationId: 'zos',
          url: '/products/zos',
          pricingUrl: null,
          external: false,
        },
        {
          name: 'z/TPF',
          longDescription: 'Real-time operating system for mainframes',
          translationId: 'ztpf',
          url: '/products/z-transaction-processing-facility',
          pricingUrl: null,
          external: false,
        },
      ],
    },
    {
      name: 'Quantum',
      translationId: 'quantum',
      description: 'Run code on real quantum systems using a full-stack SDK',
      icon: 'quantum',
      link: 'https://www.ibm.com/quantum',
      products: [
        {
          name: 'Qskit Runtime',
          longDescription: 'Python SDK for open source quantum development',
          translationId: 'qskitRuntime',
          url: 'https://www.ibm.com/quantum/qiskit-runtime',
          pricingUrl: null,
          external: false,
        },
        {
          name: 'Quantum Safe',
          longDescription:
            'Get help migrating your organization to quantum-safe cryptography',
          translationId: 'quantumSafe',
          url: 'https://www.ibm.com/quantum/quantum-safe',
          pricingUrl: null,
          external: false,
        },
        {
          name: 'Quantum Systems',
          longDescription:
            'On-premise and IaaS hardware with up to 127 qubit processors',
          translationId: 'quantumSystems',
          url: 'https://www.ibm.com/quantum/systems',
          pricingUrl: null,
          external: false,
        },
      ],
    },
    {
      name: 'Security & identity',
      description: 'Secure your resources and simplify regulatory compliance',
      icon: 'security',
      translationId: 'securityIdentity',
      external: false,
      products: [
        {
          name: 'Cloud Pak for Security',
          longDescription:
            'Security auditing, reporting, analysis and governance',
          url: '/products/cloud-pak-for-security',
          pricingUrl: '/products/cloud-pak-for-security/pricing',
          translationId: 'pakSecurity',
          external: false,
        },
        {
          name: 'Guardium',
          longDescription:
            'Software and hardware appliances for database security',
          translationId: 'guardium',
          url: '/guardium',
          pricingUrl: null,
          external: false,
        },
        {
          name: 'MaaS360',
          longDescription:
            'Unified endpoint management software for many device types',
          translationId: 'maas360',
          url: '/products/maas360',
          pricingUrl: null,
          external: false,
        },
        {
          name: 'QRadar SIEM',
          longDescription:
            'Software and network appliances for real-time security analysis',
          translationId: 'qradarSiem',
          url: '/products/qradar-siem',
          pricingUrl: null,
          external: false,
        },
        {
          name: 'QRadar SOAR',
          longDescription:
            'Software for security event response workflow automation',
          translationId: 'qradarSoar',
          url: '/products/qradar-soar',
          pricingUrl: null,
          external: false,
        },
        {
          name: 'QRadar XDR Connect',
          longDescription:
            'Software to monitor and mitigate security threats with AI',
          translationId: 'qradarConnect',
          url: '/products/qradar-xdr-connect',
          pricingUrl: null,
          external: false,
        },
        {
          name: 'ReaQta',
          longDescription:
            'Hypervisor-based endpoint security automation software',
          translationId: 'reaqta',
          url: '/products/reaqta',
          pricingUrl: null,
          external: false,
        },
        {
          name: 'Trusteer',
          longDescription:
            'Software to authenticate customers, detect fraud and assess risk',
          translationId: 'trusteer',
          url: '/trusteer',
          pricingUrl: null,
          external: false,
        },
        {
          name: 'Verify',
          longDescription: 'IAM software available on-premises or as SaaS',
          translationId: 'verify',
          url: '/verify',
          pricingUrl: null,
          external: false,
        },
        {
          name: 'Verify Privilege',
          longDescription:
            'Endpoint privilege management and application control software',
          translationId: 'verifyPrivilege',
          url: '/products/verify-privilege',
          pricingUrl: null,
          external: false,
        },
      ],
    },
    {
      name: 'Storage',
      translationId: 'storage',
      description:
        'Hardware, software and services for edge to core to hybrid cloud',
      icon: 'storage',
      link: '/storage',
      products: [
        {
          name: 'Cloud Object Storage',
          translationId: 'objectStorage',
          longDescription:
            'Unstructured cloud data storage with an API frontend',
          url: '/cloud/object-storage',
          pricingUrl: '/cloud/object-storage/pricing',
          external: false,
        },
        {
          name: 'DS8900F',
          longDescription:
            'Mainframe attached storage for transaction intensive workloads',
          translationId: 'ds8900f',
          url: '/products/ds8000f',
          pricingUrl: null,
          external: false,
        },
        {
          name: 'Elastic Storage System',
          longDescription:
            'Distributed storage for AI, big data and HPC workloads',
          translationId: 'elasticStorage',
          url: '/products/elastic-storage-system',
          pricingUrl: null,
          external: false,
        },
        {
          name: 'FlashSystem',
          longDescription:
            'Primary storage for performance and latency sensitive workloads',
          translationId: 'flashSystem',
          url: '/flashsystem',
          pricingUrl: null,
          external: false,
        },
        {
          name: 'SAN Switches',
          longDescription:
            'Networking hardware to connect hosts over fast data fabrics',
          translationId: 'sanSwitches',
          url: '/storage-area-network',
          pricingUrl: null,
          external: false,
        },
        {
          name: 'Spectrum Fusion',
          longDescription:
            'Container-native storage for Red Hat OpenShift and Kubernetes',
          translationId: 'spectrumFusion',
          url: '/products/spectrum-fusion',
          pricingUrl: null,
          external: false,
        },
        {
          name: 'Spectrum Protect',
          longDescription:
            'Data resiliency, backup and recovery delivered via SaaS',
          translationId: 'spectrumProtect',
          url: '/products/data-protection-and-recovery',
          pricingUrl: null,
          external: false,
        },
        {
          name: 'Tape Libraries',
          longDescription:
            'Long-term and physically air-gapped sustainable archival storage',
          translationId: 'tapeLibraries',
          url: '/storage/tape',
          pricingUrl: null,
          external: false,
        },
      ],
    },
    {
      name: 'Supply chain',
      translationId: 'supplyChain',
      description: 'Manage the flow of goods and services',
      icon: 'supply-chain',
      link: '/supply-chain',
      products: [
        {
          name: 'Sterling',
          longDescription:
            'Software suite and network for complete supply chain management',
          translationId: 'sterling',
          url: '/supply-chain/sterling',
          pricingUrl: null,
          external: false,
        },
        {
          name: 'Supply Chain Intelligence Suite',
          longDescription:
            'Software for supply chain optimization and automation',
          translationId: 'supplyChainSuite',
          url: '/products/supply-chain-intelligence-suite',
          pricingUrl: null,
          external: false,
        },
      ],
    },
  ],
};
